import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { RequestsListContainer } from './containers/requests-list/requests-list.container';
import { RequestFormContainer } from './containers/request-form/request-form.container';
import { RequestDetailsContainer } from './containers/request-details/request-details.container';

export const FinanceRequestsModule: React.FC = () => {
  const children = APP_ROUTES.FINANCE_REQUESTS_MODULE.CHILDREN as RouteConfig;

  return (
    <>
      <Route exact path={APP_ROUTES.FINANCE_REQUESTS_MODULE.FULL_PATH}>
        <Redirect to={children.LIST.FULL_PATH} />
      </Route>
      <Route path={children.LIST.FULL_PATH} component={RequestsListContainer} />
      <Route path={children.NEW.FULL_PATH} component={RequestFormContainer} />
      <Route path={children.EDIT.FULL_PATH} component={RequestFormContainer} />
      <Route path={children.DETAILS.FULL_PATH} component={RequestDetailsContainer} />
    </>
  );
};
